import { apiRequest } from '@common/api/utils';

const BASE_URL = '/api/v3/placement_report';
const PLACEMENT_REPORT_DOWNLOAD_ENDPOINT = `${BASE_URL}/download`;

export const downloadReport = ({ source = 'alumni_page' }) => {
  const result = apiRequest(
    'POST',
    PLACEMENT_REPORT_DOWNLOAD_ENDPOINT,
    {
      source,
    },
  );

  return result;
};
